// extracted by mini-css-extract-plugin
export default {"container":"w3-z","heading":"x3-z","links":"y3-z","copy":"z3-z","subCopy":"A3-z","linksLeft":"B3-z","linksCenter":"C3-z","linksRight":"D3-z","link":"E3-z","onlyLink":"F3-z"};